import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  selectedStatus: {
    id: 'MEUS_LOCAIS',
    description: 'Meus locais de coleta',
    value: ['RESPONDIDA'],
  },
  searchText: null,
  municipiosColeta: null,
  municipiosEntrega: null,
  estadosColeta: null,
  estadosEntrega: null,
  peso: null,
  valorMercadoria: null,
  selectedSort: null,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
